export const MANAGE_COLLECTIONS_FILTERS_ID = 'manage-collections-filters';

export const MANAGE_COLLECTIONS_TABLE_ID = 'manage-collections-table';

export const COLLECTION_NAME_ARIA_LABEL_ID = 'collection-name-input';
export const COLLECTION_TYPE_ARIA_LABEL_ID = 'collection-type-radio';
export const COLLECTION_DESCRIPTION_ARIA_LABEL_ID = 'collection-description-input';

export const COLLECTION_TYPE_RADIO_NAME = 'collection-type-radio';
export const COLLECTION_TYPE_LABEL = 'Collection type';
